import { 
    USER_AUTHENTICATE,
    USER_AUTHENTICATE_PENDING,
    USER_AUTHENTICATE_REJECTED,
    USER_AUTHENTICATE_FULFILLED,

    USER_AUTHENTICATE_CACHE,
    USER_AUTHENTICATE_RESET
} from '../_actions/user';
import _ from 'lodash';

const initialState = {
    loading: false,
    error: null,
    user: null,
    token: null
};

const user = (state = initialState, action) => {
    switch(action.type) {
        case USER_AUTHENTICATE_PENDING: {
            return Object.assign({}, state, {
                loading: true,
                error: null,
                user: null,
                token: null
            })
        }
        case USER_AUTHENTICATE_FULFILLED: {
            const { user, token } = action.payload;

            sessionStorage.setItem('@user', JSON.stringify(user));

            return Object.assign({}, state, {
                loading: false,
                error: null,
                source: user,
                token: token,
            });
        }
        case USER_AUTHENTICATE_REJECTED: {
            let error = action.error;
            if(_.hasIn(error, 'response.data.error')) {
                error = error.response.data.error;
            };
            return Object.assign({}, state, {
                loading: false,
                error: error,
                source: null,
                token: null,
            });            
        }

        case USER_AUTHENTICATE_RESET: {
            return initialState
        }

        case USER_AUTHENTICATE_CACHE: {
            return Object.assign({}, state, {
                loading: false,
                error: null,
                source: action.user.user,
                token: action.user.token,
            })
        }

        default: {
            return state
        }
    }
};

export default user;


// WEBPACK FOOTER //
// ./src/_reducers/user.js